import React, { useEffect, useMemo, useRef, useState } from 'react';
import styles from './UIGameLayout.module.scss';
import { UIGameEnd } from '../UIGameEnd/index.ts';
import { UIGameFeeds } from '../UIGameFeeds/UIGameFeeds.tsx';
import { UIGamePause } from '../UIGamePause/UIGamePause.tsx';
import { UIGameHelpButtons } from '../UIGameHelpButtons/UIGameHelpButtons.tsx';
import { StorageWrapper } from '../../utils/storage.ts';
import { UIGameSpectators } from '../UIGameSpectators/UIGameSpectators.tsx';
import { UIGameCardAnimator } from '../UIGameCardAnimator/UIGameCardAnimator.tsx';
import { UIGameVoteContainer } from '../UIGameVote/UIGameVoteContainer.tsx';
import { UIGameEndReturnToStats } from '../UIGameEnd/UIGameEndReturnToStats/UIGameEndReturnToStats.tsx';
import { UIGameTradeOffers } from '../UIGameTradeOffer/UIGameTradeOffers.tsx';
import { UIGameAchievementContainer } from '../UIGameAchievement/UIGameAchievementContainer.tsx';
import { ModeSettingEnum } from '@colonist/types';
import { RUSH_INTRO_AUTO_OPEN_FOR_FIRST_N_GAMES } from '../UIGameFeeds/UIGameRushIntro/UIGameRushIntroConstants.ts';
import { UIGameBank } from '../UIGameBank/index.ts';
import { UIGamePlayerInformationContainer } from '../UIGamePlayerInformation/UIGamePlayerInformationContainer.tsx';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { UIGameTimerBarContainer } from '../UIGameTimerBar/UIGameTimerBarContainer.tsx';
import { UIGameBarbarianInvasionTrackerContainer } from '../UIGameBarbarianInvasionTracker/UIGameBarbarianInvasionTrackerContainer.tsx';
import { UIGameReplayControlsContainer } from '../UIGameReplayControls/UIGameReplayControlsContainer.tsx';
import { useIsReplay } from '../../store/selectors/useIsReplay.ts';
import clsx from 'clsx';
import { UIGameBeginnerHint } from '../UIGameBeginnerHint/index.ts';
import { UIGameBottomLandscape, UIGameBottomPortrait } from '../UIGameBottom/index.ts';
import { UIGamePortraitTop } from '../UIGamePortraitTop/index.ts';
import { useUIGameLandscapeResponsive } from './useUIGameResponsive.ts';
import { useDeviceOrientation } from '../../hooks/useDeviceOrientation.ts';
import { UIGameRotateDevice } from '../UIGameRotateDevice/UIGameRotateDevice.tsx';
import { UIGamePlayerInfoContainerAll } from '../UIGamePlayerInfoContainerAll/UIGamePlayerInfoContainerAll.tsx';
import { UIGameSettingsDialogContainer } from '../UIGameSettingsDialog/UIGameSettingsDialogContainer.tsx';
export const UIGameLayout = (props)=>{
    const gameOrientation = useGameStore((state)=>state.gameClientConfig.gameOrientation);
    if (gameOrientation === 'portrait') return /*#__PURE__*/ React.createElement(UIGameLayoutPortrait, props);
    else return /*#__PURE__*/ React.createElement(UIGameLayoutLandscape, props);
};
export const UIGameLayoutLandscape = ({ isChatEnabled, initialCanResign })=>{
    const onClickLogForReplay = useGameStore((state)=>{
        var _state_gameReplay_replayControls;
        return (_state_gameReplay_replayControls = state.gameReplay.replayControls) === null || _state_gameReplay_replayControls === void 0 ? void 0 : _state_gameReplay_replayControls.onClickLog;
    });
    const onClickLog = onClickLogForReplay !== null && onClickLogForReplay !== void 0 ? onClickLogForReplay : ()=>void 0;
    const isReplay = useIsReplay();
    const containerRef = useRef(null);
    const containerFontSize = useUIGameLandscapeResponsive(containerRef);
    return /*#__PURE__*/ React.createElement("div", {
        ref: containerRef,
        className: clsx(styles.containerLandscape),
        style: {
            '--container-font-size': `${containerFontSize}rem`,
            gridTemplateColumns: `
                                    [start]
                                    auto
                                    [help-buttons-end] 
                                    1fr
                                    [game-feeds]
                                    19em
                                    [end]`,
            gridTemplateRows: `
                                    [start]
                                    1fr
                                    [game-feeds-end]
                                    auto
                                    [bank-end]
                                    21.25em
                                    [end]`
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.gameTopLeftContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.gameHelpButtonsContainer
    }, /*#__PURE__*/ React.createElement(UIGameHelpButtons, {
        className: styles.gameHelpButtonsLayer,
        initialCanResign: initialCanResign
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameSpectatorsContainer
    }, /*#__PURE__*/ React.createElement(UIGameSpectators, null)), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameBarbarianInvasionTrackerContainer
    }, /*#__PURE__*/ React.createElement(UIGameBarbarianInvasionTrackerContainer, null))), /*#__PURE__*/ React.createElement(UIGameSettingsDialogContainer, null), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameEndContainer
    }, /*#__PURE__*/ React.createElement(UIGameEnd, null)), /*#__PURE__*/ React.createElement("div", {
        className: styles.gamePauseContainer
    }, /*#__PURE__*/ React.createElement(UIGamePause, null)), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameTradeOffersContainer
    }, /*#__PURE__*/ React.createElement(UIGameTradeOffers, {
        className: styles.gameTradeOffersWrapper
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameBottomContainer
    }, /*#__PURE__*/ React.createElement(UIGameBottomLandscape, null)), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameAchievementContainer
    }, /*#__PURE__*/ React.createElement(UIGameAchievementContainer, null)), /*#__PURE__*/ React.createElement(UIGameFeeds, {
        className: styles.gameFeedsContainer,
        isChatEnabled: isChatEnabled,
        onClickLog: onClickLog
    }), /*#__PURE__*/ React.createElement(UIGameBank, {
        className: styles.gameBankContainer,
        isLandscape: true
    }), /*#__PURE__*/ React.createElement(UIGamePlayerInformationContainer, {
        className: styles.gamePlayerInformationContainer
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameReplayControlsContainer
    }, isReplay === true && /*#__PURE__*/ React.createElement("div", {
        className: styles.gameReplayControlsContainerInner
    }, /*#__PURE__*/ React.createElement(UIGameReplayControlsContainer, {
        useMinimalControls: false
    })), /*#__PURE__*/ React.createElement(UIGameEndReturnToStats, {
        text: "strings:game.endGame.cornerButton.openStats"
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameCardAnimatorContainer
    }, /*#__PURE__*/ React.createElement(UIGameCardAnimator, null)), /*#__PURE__*/ React.createElement(UIGameBeginnerHint, null));
};
export const UIGameLayoutPortrait = ({ initialCanResign })=>{
    var _useGameStore;
    const safeAreaTop = (_useGameStore = useGameStore((state)=>state.gameClientConfig.safeAreaInsetTop)) !== null && _useGameStore !== void 0 ? _useGameStore : 0;
    var _useGameStore1;
    const safeAreaBottom = ((_useGameStore1 = useGameStore((state)=>state.gameClientConfig.safeAreaInsetBottom)) !== null && _useGameStore1 !== void 0 ? _useGameStore1 : 0) * 0.5;
    const isReplay = useIsReplay();
    const modeSetting = useGameStore((state)=>state.gameSettings.modeSetting);
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P;
    const isRushGame = modeSetting == ModeSettingEnum.ColonistRush4P;
    const shouldAutoOpenRushIntro = isRushGame && StorageWrapper.getRushGamesPlayed() < RUSH_INTRO_AUTO_OPEN_FOR_FIRST_N_GAMES;
    const [feedsPortraitVisibility, setFeedsPortraitVisibility] = useState(shouldAutoOpenRushIntro ? 'rush' : 'none');
    const onClickLogForReplay = useGameStore((state)=>{
        var _state_gameReplay_replayControls;
        return (_state_gameReplay_replayControls = state.gameReplay.replayControls) === null || _state_gameReplay_replayControls === void 0 ? void 0 : _state_gameReplay_replayControls.onClickLog;
    });
    const onClickLog = (index)=>onClickLogForReplay === null || onClickLogForReplay === void 0 ? void 0 : onClickLogForReplay(index);
    var _StorageWrapper_getPlayerInfoSectionUsedDevsActive;
    const [isPlayerInfoSectionUsedDevsActive, setIsPlayerInfoSectionUsedDevsActive] = useState((_StorageWrapper_getPlayerInfoSectionUsedDevsActive = StorageWrapper.getPlayerInfoSectionUsedDevsActive()) !== null && _StorageWrapper_getPlayerInfoSectionUsedDevsActive !== void 0 ? _StorageWrapper_getPlayerInfoSectionUsedDevsActive : false);
    var _StorageWrapper_getPlayerInfoSectionCKActive;
    const [isPlayerInfoSectionCKActive, setIsPlayerInfoSectionCKActive] = useState((_StorageWrapper_getPlayerInfoSectionCKActive = StorageWrapper.getPlayerInfoSectionCKActive()) !== null && _StorageWrapper_getPlayerInfoSectionCKActive !== void 0 ? _StorageWrapper_getPlayerInfoSectionCKActive : false);
    var _StorageWrapper_getPlayerInfoSectionPiecesActive;
    const [isPlayerInfoSectionPiecesActive, setIsPlayerInfoSectionPiecesActive] = useState((_StorageWrapper_getPlayerInfoSectionPiecesActive = StorageWrapper.getPlayerInfoSectionPiecesActive()) !== null && _StorageWrapper_getPlayerInfoSectionPiecesActive !== void 0 ? _StorageWrapper_getPlayerInfoSectionPiecesActive : false);
    useEffect(()=>{
        StorageWrapper.setPlayerInfoSectionUsedDevsActive(isPlayerInfoSectionUsedDevsActive);
    }, [
        isPlayerInfoSectionUsedDevsActive
    ]);
    useEffect(()=>{
        StorageWrapper.setPlayerInfoSectionCKActive(isPlayerInfoSectionCKActive);
    }, [
        isPlayerInfoSectionCKActive
    ]);
    useEffect(()=>{
        StorageWrapper.setPlayerInfoSectionPiecesActive(isPlayerInfoSectionPiecesActive);
    }, [
        isPlayerInfoSectionPiecesActive
    ]);
    const visiblePlayerInfoSections = useMemo(()=>{
        if (isBeginnerMode) return [
            'hand'
        ];
        return [
            'hand',
            'pieces',
            'usedDevs',
            'ck'
        ].filter((section)=>{
            if (section === 'usedDevs') return isPlayerInfoSectionUsedDevsActive;
            if (section === 'ck') return isPlayerInfoSectionCKActive;
            if (section === 'pieces') return isPlayerInfoSectionPiecesActive;
            return true;
        });
    }, [
        isBeginnerMode,
        isPlayerInfoSectionUsedDevsActive,
        isPlayerInfoSectionCKActive,
        isPlayerInfoSectionPiecesActive
    ]);
    const deviceOrientation = useDeviceOrientation();
    const enableRotateDeviceWarning = useGameStore((state)=>state.gameClientConfig.enableRotateDeviceWarning);
    if (deviceOrientation === 'landscape' && enableRotateDeviceWarning) {
        return /*#__PURE__*/ React.createElement(UIGameRotateDevice, null);
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.containerPortrait,
        style: {
            gridTemplateColumns: 'minmax(0, 1fr)',
            gridTemplateRows: `
                                    [start]
                                    ${safeAreaTop}px
                                    [safe-area-top-end]
                                    min-content
                                    [help-buttons-end]
                                    min-content
                                    [player-information-container-end]
                                    minmax(min(20vh, 80px), 1fr)
                                    [bottom-start]
                                    auto
                                    [timer-bar-start]
                                    auto
                                    [safe-area-bottom-start]
                                    ${safeAreaBottom}px
                                    [end]`
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.gameHelpBackground
    }), /*#__PURE__*/ React.createElement(UIGamePortraitTop, {
        initialCanResign: initialCanResign,
        className: styles.gameTopContainer,
        isPlayerInfoSectionUsedDevsActive: isPlayerInfoSectionUsedDevsActive,
        setIsPlayerInfoSectionUsedDevsActive: setIsPlayerInfoSectionUsedDevsActive,
        isPlayerInfoSectionCKActive: isPlayerInfoSectionCKActive,
        setIsPlayerInfoSectionCKActive: setIsPlayerInfoSectionCKActive,
        isPlayerInfoSectionPiecesActive: isPlayerInfoSectionPiecesActive,
        setIsPlayerInfoSectionPiecesActive: setIsPlayerInfoSectionPiecesActive
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.gamePlayerInfoContainer
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoContainerAll, {
        visibleSections: visiblePlayerInfoSections
    })), isReplay === false && /*#__PURE__*/ React.createElement("div", {
        className: styles.gameTradeOffersContainer
    }, /*#__PURE__*/ React.createElement(UIGameTradeOffers, {
        className: styles.gameTradeOffersWrapper,
        disableTooltips: true
    })), isReplay === false && isBeginnerMode === false && /*#__PURE__*/ React.createElement("div", {
        className: styles.gameTimerBarContainer
    }, /*#__PURE__*/ React.createElement(UIGameTimerBarContainer, null)), /*#__PURE__*/ React.createElement(UIGameSettingsDialogContainer, {
        hiddenSettingsTabs: [
            'controls'
        ]
    }), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameEndContainer
    }, /*#__PURE__*/ React.createElement(UIGameEnd, null)), /*#__PURE__*/ React.createElement("div", {
        className: styles.gamePauseContainer
    }, /*#__PURE__*/ React.createElement(UIGamePause, null)), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameAchievementContainer
    }, /*#__PURE__*/ React.createElement(UIGameAchievementContainer, null)), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameBarbarianInvasionTrackerContainer
    }, /*#__PURE__*/ React.createElement(UIGameBarbarianInvasionTrackerContainer, null)), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameCardAnimatorContainer
    }, /*#__PURE__*/ React.createElement(UIGameCardAnimator, null)), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameVoteContainer
    }, /*#__PURE__*/ React.createElement(UIGameVoteContainer, null)), /*#__PURE__*/ React.createElement("div", {
        className: styles.gameBottomContainer
    }, /*#__PURE__*/ React.createElement(UIGameBottomPortrait, {
        onClickLog: onClickLog,
        feedsPortraitVisibility: feedsPortraitVisibility,
        setFeedsPortraitVisibility: setFeedsPortraitVisibility
    })), /*#__PURE__*/ React.createElement(UIGameBeginnerHint, null));
};
